import styled from 'styled-components';

const Tagline = styled.p`
  font-size: 0.75em;
  text-transform: uppercase;
  letter-spacing: 3px;
  font-weight: 700;
`;

export default Tagline;
